import { useNavigate } from "react-router-dom"
import { Typography } from "@mui/material"

import StyledPaper from "/components/paper"

import couponImage from '/assets/dashboard/coupon-template.png'
import eventImage from '/assets/dashboard/event-template.png'

const Templates = () => {

  const navigate = useNavigate()

  return (
    <StyledPaper width={250} height={250}>
      <div onClick={() => navigate("/templates")} className="link flex flex-col items-center justify-top h-full">
        <Typography variant="h5">Templates</Typography>
      </div>
      <div onClick={() => navigate("/templates")} className="link relative">
        <img src={couponImage} style={{ position: "absolute", left: "50%", bottom: 20, height: "130px", display: "inline-block", transform: "rotate(10deg) translateX(-50%)", filter: "drop-shadow(0 8px 12px rgba(0, 0, 0, 1))" }} />
        <img src={eventImage} style={{ position: "absolute", left: "50%", bottom: 40, height: "130px", display: "inline-block", transform: "rotate(-15deg) translateX(-50%)", filter: "drop-shadow(0 8px 12px rgba(0, 0, 0, 1))" }} />
      </div>
    </StyledPaper>
  )
}

export default Templates